import { List as MuiList, ListItem as MuiListItem, styled } from '@mui/material';

const List = styled(MuiList)(({ theme }) => ({
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
}));
const ListItem = styled(MuiListItem)(({ theme }) => ({
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
}));

export { List, ListItem };
